/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-13 14:02:51
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2022-05-17 13:31:02
 * @Description:icon组件
 * @FilePath: /hsylc2021/src/components/icons/index.js
 */
export { default as Close } from './Close';
export { default as Tick } from './Tick';
export { default as Arrow } from './Arrow';
export { default as Menu } from './Menu';
export { default as User } from './User';
export { default as Next } from './Next';
export { default as Plus } from './Plus';
export { default as Eye } from './Eye';
export { default as CloseEye } from './CloseEye';
export { default as Ok } from './Ok';
export { default as Dialogue } from './Dialogue';
